export default __webpack_public_path__ + "static/media/linux.df350ab7.svg";